import React from "react";

export const getHighlightedTextList = (textList = [], highlight) => {
  const response = {
    messages: [],
    index: null
  };

  Array.isArray(textList) && textList.filter(row => row).map((row, index) => {
    if(row.content) {
      let parts = row.content.split(new RegExp(`(${highlight})`, "gi"))
      parts = parts.find(part => part.toLowerCase() === highlight.toLowerCase());

      console.log("PARTS", parts)

      if(parts) {
        response.messages.push({ content: row.content, position: index });
        response.index = index;
      }
    }
  });

  return response;
}

export const getHighlightedText = (text, highlight, notLoggedUser) => {
  if(!text) {
    return <div>--</div>
  }

  let parts = text.split(new RegExp(`(${highlight})`, "gi"));

  const styleLoggedUser = notLoggedUser
    ? { backgroundColor: "#0146ad", color: "#FFF" }
    : { backgroundColor: "#F2F2F2", color: "#000" }

  return parts.map((part, index) => (
    <React.Fragment key={index}>
      {part.toLowerCase() === highlight.toLowerCase() ? (
        <span style={styleLoggedUser}>{part}</span>
      ) : (
        part
      )}
    </React.Fragment>
  ))
}